import React from 'react';
import { messageService } from '../centro-atencion-gnp/centro-atencion.service';
import { connect } from "react-redux";

const mapState = (state) => {
    return {
        dispositivo: state.global.dispositivo
    };
}

const mapDispatch = (dispatch) => {
    return {
        tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
    }
}
class CentroAtencionGNP extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            messages: []
        };
        this.src = "";
    }

    componentWillMount = () => {
        console.log("MONTAR");
        this.src = localStorage.getItem('urlIframeActual')
        console.log(this.src);
        this.subscription = messageService.getMessage().subscribe(message => {
            if (message) {
                this.setState({ messages: [...this.state.messages, message.text] });
                this.props.tagManager({ "type": "EVENT_CENTRO_ATENCION-GNP", "dispositivo": this.props.dispositivo });
                this.src = message.text;
            } else {
                this.setState({ messages: [] });
            }
        })
    }

    componentWillUnmount() {
        console.log(this.src);
        localStorage.setItem('urlIframeActual', this.src)
        this.subscription.unsubscribe();
    }

    render() {
        return <iframe className="centro-atencion-iframe-responsive" src={this.src} frameborder="0" ></iframe>
    }
}

export default connect(mapState, mapDispatch)(CentroAtencionGNP);



// WEBPACK FOOTER //
// ./src/centro-atencion-gnp/centro-atencion.cmpt.js